module.exports = __webpack_public_path__ + "img/truck-1.fa19f3a9.png";